import React, { Component } from 'react';

import Container from 'react-bootstrap/Container';

import DonationPrompt from '../component/donationPrompt'
import Waiver from '../component/waiver'
import PageHeader from '../component/pageHeader';
import PropTypes from "prop-types";
import Footer from '../component/footer';
import { hasDonated } from '../state/cartActions';
import { withRouter } from "react-router";
import Welcome from "../component/welcome";
import PageMessage from "../component/pageMessage";
import OfferingList from "../component/offeringList";
import Cart from "../component/cart";
import CheckoutButton from "../component/checkoutButton";
import Notice from "../component/notice";

class Home extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.offeringListRef = React.createRef();
        this.state = {
            showWaiver: false,
            showDonationPrompt: false
        };
    }

    render() {
        return (
            <Container className="mx-auto">
                <PageHeader />
                <div className="row">
                    <section className="col-lg-9">
                        <Welcome key="welcome"/>
                        <PageMessage />
                        {/*<MaintenanceMessage />*/}
                        <OfferingList key="offering" innerRef={this.offeringListRef} />
                    </section>
                    <section className="col-lg-3">
                        <Cart edit={true}/>
                        <CheckoutButton onClick={() => this.showDonationPrompt()}/>
                        <Notice />
                        <img className="img-fluid" src="/images/WisConRegistrationBookwyrm.png" style={{width: "100%" }} alt="WisCon registration bookwyrm"/>
                    </section>
                </div>
                <DonationPrompt show={this.state.showDonationPrompt} onClose={(accepted) => { this.donationPromptClose(accepted) } }/>
                <Waiver show={this.state.showWaiver} onClose={(accepted) => { this.waiverClose(accepted) } }/>

                <Footer />
            </Container>
        );
    }

    showDonationPrompt() {
        let userHasDonated = hasDonated();
        this.setState({
            showDonationPrompt: !userHasDonated,
            showWaiver: userHasDonated
        });
    }

    donationPromptClose(accepted) {
        this.setState({
            showDonationPrompt: false,
            showWaiver: !accepted
        });
        if (accepted) {
            this.offeringListRef.current?.click();
        }
    }

    waiverClose(accepted) {
        this.setState({
            showWaiver: false
        });
        if (accepted) {
            const { history } = this.props;
            history.push('/checkout');    
        }
    }
}

export default withRouter(Home);